import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <p>© 2020 Airbnb clone! No rights rights reserved - this is a demo!</p>
            <p>Privacy · Terms · Sitemap · Company Detail</p>
        </div>
    );
};

export default Footer;